import { BaseTransactionParser } from '../../parser';
import * as thorchain from '../../parser/thorchain';
export class TransactionParser extends BaseTransactionParser {
    constructor(args) {
        super(args);
        this.registerParsers([new thorchain.Parser({ midgardUrl: args.midgardUrl })]);
    }
}
